var map = {
	"./add-client.png": "./src/assets/images/add-client.png",
	"./advanced-analytics-image.svg": "./src/assets/images/advanced-analytics-image.svg",
	"./api-image.svg": "./src/assets/images/api-image.svg",
	"./city-color.svg": "./src/assets/images/city-color.svg",
	"./city.svg": "./src/assets/images/city.svg",
	"./commandCenter.svg": "./src/assets/images/commandCenter.svg",
	"./computer.svg": "./src/assets/images/computer.svg",
	"./consulting.svg": "./src/assets/images/consulting.svg",
	"./convert.png": "./src/assets/images/convert.png",
	"./create-task.png": "./src/assets/images/create-task.png",
	"./csv.svg": "./src/assets/images/csv.svg",
	"./danger_blank.svg": "./src/assets/images/danger_blank.svg",
	"./doc.svg": "./src/assets/images/doc.svg",
	"./docx.svg": "./src/assets/images/docx.svg",
	"./download-appstore.svg": "./src/assets/images/download-appstore.svg",
	"./download-playstore.svg": "./src/assets/images/download-playstore.svg",
	"./dynamic_allocation.svg": "./src/assets/images/dynamic_allocation.svg",
	"./edit-category.svg": "./src/assets/images/edit-category.svg",
	"./edith-image.svg": "./src/assets/images/edith-image.svg",
	"./form-img.svg": "./src/assets/images/form-img.svg",
	"./gif.svg": "./src/assets/images/gif.svg",
	"./groupTask.svg": "./src/assets/images/groupTask.svg",
	"./idia.svg": "./src/assets/images/idia.svg",
	"./invoice-background-image.png": "./src/assets/images/invoice-background-image.png",
	"./iso-image.svg": "./src/assets/images/iso-image.svg",
	"./jpeg.png": "./src/assets/images/jpeg.png",
	"./jpg.svg": "./src/assets/images/jpg.svg",
	"./logo-fielder-register.png": "./src/assets/images/logo-fielder-register.png",
	"./logo-fielder-register.svg": "./src/assets/images/logo-fielder-register.svg",
	"./logo-fielder.png": "./src/assets/images/logo-fielder.png",
	"./mail-integration-image.svg": "./src/assets/images/mail-integration-image.svg",
	"./market-network.svg": "./src/assets/images/market-network.svg",
	"./market-puzzle.svg": "./src/assets/images/market-puzzle.svg",
	"./market-sections.svg": "./src/assets/images/market-sections.svg",
	"./market-start-up.svg": "./src/assets/images/market-start-up.svg",
	"./massive-download-image.svg": "./src/assets/images/massive-download-image.svg",
	"./maya.svg": "./src/assets/images/maya.svg",
	"./mp4.png": "./src/assets/images/mp4.png",
	"./mp4.svg": "./src/assets/images/mp4.svg",
	"./msg.svg": "./src/assets/images/msg.svg",
	"./odp.svg": "./src/assets/images/odp.svg",
	"./ods.svg": "./src/assets/images/ods.svg",
	"./odt.svg": "./src/assets/images/odt.svg",
	"./pdf.png": "./src/assets/images/pdf.png",
	"./pdf.svg": "./src/assets/images/pdf.svg",
	"./png.svg": "./src/assets/images/png.svg",
	"./ppt.svg": "./src/assets/images/ppt.svg",
	"./pptx.svg": "./src/assets/images/pptx.svg",
	"./resourceAllocation-image.svg": "./src/assets/images/resourceAllocation-image.svg",
	"./role-management-image.svg": "./src/assets/images/role-management-image.svg",
	"./route-preferences.svg": "./src/assets/images/route-preferences.svg",
	"./routeOptimization-image.svg": "./src/assets/images/routeOptimization-image.svg",
	"./routesimage.svg": "./src/assets/images/routesimage.svg",
	"./skills-image.svg": "./src/assets/images/skills-image.svg",
	"./sms-bubble-image.svg": "./src/assets/images/sms-bubble-image.svg",
	"./sms-image.svg": "./src/assets/images/sms-image.svg",
	"./storage.svg": "./src/assets/images/storage.svg",
	"./support.svg": "./src/assets/images/support.svg",
	"./taskType.svg": "./src/assets/images/taskType.svg",
	"./tasks.svg": "./src/assets/images/tasks.svg",
	"./test.svg": "./src/assets/images/test.svg",
	"./tif.png": "./src/assets/images/tif.png",
	"./tiff.png": "./src/assets/images/tiff.png",
	"./tutorial-agent.svg": "./src/assets/images/tutorial-agent.svg",
	"./tutorial-assign-agent.svg": "./src/assets/images/tutorial-assign-agent.svg",
	"./tutorial-create-task.svg": "./src/assets/images/tutorial-create-task.svg",
	"./tutorial-download-app.svg": "./src/assets/images/tutorial-download-app.svg",
	"./tutorial-personalize.png": "./src/assets/images/tutorial-personalize.png",
	"./txt.svg": "./src/assets/images/txt.svg",
	"./xls.svg": "./src/assets/images/xls.svg",
	"./xlsx.svg": "./src/assets/images/xlsx.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";